module.exports = __webpack_public_path__ + "static/media/Team 4.72af4ffd.png";